import React from "react";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import styles from "./Blogs.module.scss";
import BlogCard from "./BlogCard";
import blogImg from "../../../assets/new-images/blog-3.jpg";
import miniBlogImg from "../../../assets/new-images/blog-3.jpg";
 
const Blogs = () => {
  const blogsData = [
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
  ];
  return (
    <div className={styles.blogs}>
      <NewUiHeader />
      <section className="common_padding">
        <div className="container">
          <h3 className="text-left">Our Blogs</h3>
          <div className={styles.blogs_flex_data}>
            <div className={styles.img_div}>
              <img src={blogImg} alt="blog image" />
              <div className={styles.banner_content}>
                <span>Adventure & Activities</span>
                <h4>
                  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo mauris
                  tristique.{" "}
                </h4>
                <small>26 March 2025</small>
                <div className="flex justify_content_center mt-20">
                  <div className={styles.next_icon}>
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_6868_17700"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="17"
                      >
                        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6868_17700)">
                        <path
                          d="M5.33595 14.705L4.62695 13.996L10.1231 8.49984L4.62695 3.00368L5.33595 2.29468L11.5411 8.49984L5.33595 14.705Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.content_sec}>
              <h4>must reads</h4>
              {blogsData?.map((item, i) => (
                <div className="flex flex_gap_10" key={i}>
                  <div className={styles.mini_img}>
                    <img src={item?.image} alt="blog image" />
                  </div>
                  <div>
                    <h5>{item.title}</h5>
                    <span>Adventure & Activities</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="common_padding">
        <div className="container">
          <div className={styles.heading_flex}>
            <div></div>latest posts <div></div>
          </div>
          <BlogCard />
        </div>
      </section>
      <section className="common_padding">
        <div className="container">
          <div className={styles.heading_flex}>
            <div></div>The Archives <div></div>
          </div>
          <BlogCard />
        </div>
      </section>
      <NewFooterUI />
    </div>
  );
};
 
export default Blogs;